import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import { fetchHelper } from './Scene7Player';
import * as styles from './Scene7Player.css';

const cx = classNames.bind(styles);

const localConfig = {
    params: {
        serverurl: 'https://jcpenney.scene7.com/is/image/',
        contenturl: 'https://jcpenney.scene7.com/is/content/',
    },
    adobeVideoPlaceholder:
        'https://www.static-jcpenney.com/prod3/yoda-home/assets/svg/video-error.svg',
};

/* istanbul ignore next */
class VideoPlayerForiOS extends PureComponent {
    static propTypes = {
        defaultScene7VideoSettings: PropTypes.shape({
            params: PropTypes.shape({
                serverurl: PropTypes.string.isRequired,
                contenturl: PropTypes.string.isRequired,
            }),
            config: PropTypes.string.isRequired,
            autoPlayConfig: PropTypes.string.isRequired,
            scene7VideoViewerURL: PropTypes.string.isRequired,
            adobeVideoPlaceholder: PropTypes.string.isRequired,
            containerHeightForIE: PropTypes.string,
            triggerVideoPlayTimeout: PropTypes.number,
            cycleResetTimeout: PropTypes.number,
            extraSpace: PropTypes.number,
        }),
        videoId: PropTypes.string.isRequired,
        index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        onEnd: PropTypes.func,
        disableAutoPlay: PropTypes.bool,
        automationId: PropTypes.string,
        posterHeight: PropTypes.number.isRequired,
        posterWidth: PropTypes.number.isRequired,
        isPDP: PropTypes.bool,
    };

    static defaultProps = {
        index: 0,
        onEnd: () => {},
        disableAutoPlay: false,
        automationId: '',
        defaultScene7VideoSettings: localConfig,
        isPDP: false,
    };

    constructor() {
        super();
        this.state = {
            hasCaptions: false,
        };
        this.triggered = false;
    }

    async componentWillMount() {
        this.setState({
            hasCaptions: await this.captioningExits(),
        });
    }

    /* make a call to content to see if closed captioning exists
     * returns exists=1 if CC exists
     * returns exists=0 if CC does not exists
     */
    async captioningExits() {
        const {
            defaultScene7VideoSettings: {
                params: { contenturl },
            },
            videoId = '',
        } = this.props;
        const { status, text = '' } = await fetchHelper(
            `${contenturl}/jcpenneyimages/videos/tt/${videoId}.vtt?req=exists`
        );
        if (status === 200 && text.includes('exists=1')) {
            return true;
        }
        return false;
    }

    seekIos = () => {
        const { isPDP } = this.props;
        isPDP && this.videoRef.play();
    };

    playVideo = () => {
        const { isPDP } = this.props;
        isPDP && this.goFullscreen(this.videoRef);
    };

    goFullscreen = (elem) => {
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        }
    };

    render() {
        const {
            videoId,
            index,
            disableAutoPlay,
            automationId,
            defaultScene7VideoSettings: {
                adobeVideoPlaceholder,
                params: { contenturl, serverurl },
            },
            onEnd,
            posterHeight,
            posterWidth,
            isPDP,
        } = this.props;
        const { hasCaptions, hasError } = this.state;
        const videoAutomationId = automationId || `prod-video-${index}`;
        const videoProps = { allowFullScreen: false, playsInline: true };
        if (isPDP) {
            videoProps.allowFullScreen = true;
            videoProps.playsInline = false;
        }
        return (
            <div
                className={cx(styles.videoContainer)}
                ref={(node) => {
                    this.videoContainerRef = node;
                }}
            >
                {hasError ? (
                    <img
                        src={adobeVideoPlaceholder}
                        className={styles.placeholder}
                        data-automation-id={videoAutomationId}
                        alt={`${videoId}-adobe-video-failed-to-load`}
                    />
                ) : (
                    <video
                        onCanPlay={() => (this.videoRef.textTracks[0].mode = 'hidden')}
                        onError={() => this.setState({ hasError: true })}
                        ref={(node) => {
                            this.videoRef = node;
                        }}
                        onEnded={onEnd}
                        autoPlay={!disableAutoPlay}
                        data-automation-id={videoAutomationId}
                        controls
                        onPlay={this.playVideo}
                        onSeeked={this.seekIos}
                        poster={`${serverurl}/jcpenneyimages/${videoId}?fit=constrain,1&wid=${posterWidth}&hei=${posterHeight}`}
                        preload="metadata"
                        controlsList="nodownload"
                        className="s7videoviewer"
                        {...videoProps}
                    >
                        <source
                            src={`${contenturl}/jcpenneyimages/${videoId}.m3u8`}
                            type="video/mp4"
                        />
                        {hasCaptions && (
                            <track
                                label="English"
                                kind="subtitles"
                                srcLang="en"
                                src={`${contenturl}/jcpenneyimages/videos/tt/${videoId}.vtt`}
                                default
                            />
                        )}
                    </video>
                )}
            </div>
        );
    }
}

export default VideoPlayerForiOS;
